import clsx from "clsx";

export default function Overlay({children, className, visible = false}) {
    return <div
        className={clsx('absolute top-0 left-0 right-0 bottom-0 pointer-events-none transition transition-opacity', className, visible ? 'opacity-100' : 'opacity-0')}>
        {children}
    </div>
}